// de_pms_manager_dashboard.ts
// Tłumaczenia dla ekranu Manager Dashboard (ManagerDashboard.tsx)
// Statusy pokoi, akcje, common labels → importuj z de_pms_common.ts

export const dePmsManagerDashboard = {

  // ── Tytuły modali szczegółów ──────────────────────────────────────────────
  detailTitles: {
    rooms:    { title: "Zimmer- und Bestandsstatus",        sub: "Live-Zimmerstatus auf allen Etagen" },
    guest:    { title: "Gästeerlebnis",              sub: "Zufriedenheit, Bewertungen und Service-Recovery (letzte 90 Tage)" },
    dept:     { title: "Abteilungsübersicht",                 sub: "Status, Arbeitslast und Ausnahmen nach Abteilung (heute)" },
    segments: { title: "Top-Nachfragesegmente",   sub: "Zimmernächte und Umsatz nach Segment (letzte 28 Tage)" },
    market:   { title: "Markt und Buchungsentwicklung",                    sub: "Benchmark gegen das Comp-Set" },
    labor:    { title: "Personalübersicht",            sub: "Besetzung und Kosten nach Abteilung (heute)" },
    risk:     { title: "Offene operative Risiken",       sub: "Aktive Risiken mit Handlungsbedarf" },
  },

  // ── Pasek KPI ─────────────────────────────────────────────────────────────
  kpi: {
    occupancy:        "Auslastung",
    adr:              "ADR",
    revpar:           "RevPAR",
    revenueToday:     "Umsatz heute",
    forecastPickup:   "Pickup-Prognose",
    guestSatisfaction:"Gästezufriedenheit",
    openIssues:       "Offene Probleme",
    laborCoverage:    "Personalabdeckung",
    onTheBooks:       "Buchungsstand",
    onTarget:         "Auf Kurs",
    belowPlan:        "Unter Plan",
    vsLY:             "ggü. VJ",       // vs Ubiegły Rok
    vsFCST:           "ggü. Prognose",     // vs Prognoza
  },

  // ── Sekcja wykres / Performance & Forecast ────────────────────────────────
  performanceForecast: {
    title:           "Leistung und Prognose",
    legendRevenue:   "Umsatz ($)",
    legendOccupancy: "Auslastung (%)",
    revenueToday:    "Umsatz heute",
    revenueForecast: "Umsatzprognose",
    next7Days:       "nächste 7 Tage",
  },

  // ── Pokoje i inwentarz ────────────────────────────────────────────────────
  rooms: {
    title:                  "Zimmer- und Bestandsstatus",
    viewDetails:            "Details anzeigen",
    sellableInventory:      "Verkaufbarer Bestand",
    housekeepingReadiness:  "Housekeeping-Bereitschaft",
    outOfOrder:             "Außer Betrieb",
    blockedRooms:           "Blockierte Zimmer",
    maintenanceImpact:      "Auswirkung durch Wartung",
    blockedForRevenue:      "Für Umsatz blockiert",
    noImpact:               "Keine Auswirkung",
    arrivalRoomsNotReady:   "Anreisezimmer nicht bereit",
    highPriority:           "Hohe Priorität",
    allClear:               "Alles in Ordnung",
    // Szczegóły modalu
    totalRooms:             "Alle Zimmer",
    sellable:               "Verkaufbar",
    occupied:               "Belegt",
    available:              "Verfügbar",
    dirtyBlocked:           "Schmutzig / blockiert",
    byFloor:                "Nach Etage",
    tableHeaders:           ["Etage", "Gesamt", "Belegt", "Verfügbar", "Schmutzig", "Reserviert", "OOO"],
    floorLabel:             "Etage",
    reservedForArrivals:    "für anstehende Anreisen reserviert",
    room:                   "Zimmer",
    rooms:                  "Zimmer",
    ofTotal:                "Anteil in %",
    ofOccupancy:            "% Auslastung",
  },

  // ── Doświadczenie gości ───────────────────────────────────────────────────
  guest: {
    title:             "Gästeerlebnis-Puls",
    viewDetails:       "Details anzeigen",
    satisfactionScore: "Zufriedenheitswert",
    activeComplaints:  "Aktive Beschwerden",
    vipArrivalsToday:  "VIP-Anreisen heute",
    vipInHouse:        "im Haus",
    highPriority:      "Hohe Priorität",
    noneOpen:          "Keine offenen",
    serviceRecovery:   "Offene Beschwerden",
    openCases:         "Offene Fälle",
    reviewSentiment:   "Bewertungsstimmung",
    noReviewsYet:      "Noch keine Bewertungen",
    responseSLA:       "Antwort-SLA",
    onTarget:          "Auf Kurs",
    belowTarget:       "Unter Ziel",
    noData:            "Keine Daten",
    noGuestData:       "Keine Gästeerlebnis-Daten.",
    positiveReviews:   "% positiv",
    reviews:           "Bewertungen",
    // Szczegóły modalu – tabela
    detailLabels: {
      satisfaction:    "Zufriedenheit",
      reviews90d:      "Bewertungen (90 Tage)",
      responseSLA:     "Antwort-SLA",
      complaints:      "Aktive Beschwerden",
      serviceRecovery: "Offene Beschwerden",
      openCasesLabel:  "offene Fälle",
      vipTodayInHouse: "VIP heute / im Haus",
    },
    sentiment: {
      label:    "Bewertungsstimmung",
      positive: "Positiv",
      neutral:  "Neutral",
      negative: "Negativ",
    },
  },

  // ── Przegląd działów ─────────────────────────────────────────────────────
  dept: {
    title:        "Abteilungsübersicht",
    viewAll:      "Alle anzeigen",
    noData:       "Keine Personaldaten für heute.",
    loading:      "Wird geladen...",
    atRisk:       "Gefährdet",
    onTrack:      "Im Plan",
    tableHeaders: ["Abteilung", "Status", "Arbeitslast", "Ausn.", "Verantwortlich"],
    detailHeaders:["Abteilung", "Verantwortlich", "Status", "Arbeitslast", "Plan", "Erf.", "Abdeckung", "Ausn."],
  },

  // ── Segmenty popytu ───────────────────────────────────────────────────────
  segments: {
    title:        "Top-Nachfragesegmente",
    stayDate:     "Aufenthaltsdatum",
    viewAll:      "Alle anzeigen",
    noData:       "Keine Aufenthalte in den letzten 28 Tagen.",
    loading:      "Wird geladen...",
    other:        "Sonstiges",
    total:        "Gesamt",
    tableHeaders: ["Segment", "Zimmer", "Anteil in %", "ADR", "RevPAR"],
    detailHeaders:["Segment", "Zimmernächte", "% Anteil", "Umsatz", "ADR", "RevPAR"],
  },

  // ── Rynek i tempo ─────────────────────────────────────────────────────────
  market: {
    title:            "Markt und Buchungsentwicklung",
    viewAll:          "Alle anzeigen",
    noData:           "Keine Marktdaten.",
    asOf:             "Stand:",
    marketOccupancy:  "Marktauslastung",
    marketADR:        "Markt-ADR",
    marketRevPAR:     "Markt-RevPAR",
    compSetIndex:     "Comp-Set-Index",
    aboveCompSet:     "Über Comp-Set",
    belowCompSet:     "Unter Comp-Set",
    paceToForecast:   "Buchungsentwicklung vs. Prognose",
    revenueForecast7d:"Umsatzprognose (7 Tage)",
    vs28dAgo:         "vs. vor 28 Tagen",
    onPace:           "Im Plan",
    behindPace:       "Hinter Plan",
    noForecast:       "Keine Prognose",
    description:      "Abweichungen vergleichen den aktuellen Benchmark mit demselben Wert vor 28 Tagen. Ein Comp-Set-Index über 100 bedeutet, dass das Hotel den Wettbewerb übertrifft.",
  },

  // ── Przegląd zatrudnienia ─────────────────────────────────────────────────
  labor: {
    title:         "Personalübersicht",
    viewAll:       "Alle anzeigen",
    noData:        "Keine Personaldaten.",
    coverage:      "Abdeckung",
    scheduled:     "Geplant",
    totalCost:     "Gesamte Personalkosten",
    vsRequired:    "vs. benötigt",
    required:      "benötigt",
    byDept:        "Nach Abteilung",
    noPerDept:     "Keine Daten je Abteilung.",
    onTarget:      "Auf Kurs",
    belowPlan:     "Unter Plan",
    noDataShort:   "Keine Daten",
    revenueOf:     "% des Umsatzes",
    staffingGap:   "Personalengpass",
    fullyCovered:  "Voll abgedeckt",
    tableHeaders:  ["Abteilung", "Plan", "Benötigt", "Abdeckung", "Verantwortlich"],
  },

  // ── Brief kierowniczy ─────────────────────────────────────────────────────
  leadershipBrief: {
    title:                   "Führungsbriefing",
    todaySummary:            "Tageszusammenfassung",
    upcomingHighlights:      "Bevorstehende Highlights",
    notes:                   "Notizen",
    noActiveNotes:           "Keine aktiven Notizen. Fügen Sie eine im Live Board hinzu.",
    noUpcomingGroupBlocks:   "Keine bevorstehenden Gruppenblöcke",
    pickupVsYesterday:       "Pickup vs. gestern",
    revenuePace:             "Umsatzentwicklung",
    compSetIndex:            "Comp-Set-Index",
    displacement:            "Verdrängung",
    today:                   "heute",
    groupPrefix:             "Gruppe: ",
    noReleaseDate:           "Kein Optionsdatum",
    rooms:                   "Zimmer",
    room:                    "Zimmer",
    pickupOf:                "Pickup",
  },

  // ── Kolejka ryzyk ─────────────────────────────────────────────────────────
  risk: {
    title:    "Offene operative Risiken",
    viewAll:  "Alle anzeigen",
    noRisks:  "Keine aktiven operativen Risiken",
    loading:  "Wird geladen...",
  },

} as const;

export default dePmsManagerDashboard;
